export const uniqueArray = (array: any[], field: string) => {
  return array.filter(
    (a: any, i: number) =>
      a[field] && array.findIndex((s: any) => a[field] === s[field]) === i
  );
};
